import {Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {DialogComponent} from "../../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {FormControl, Validators} from "@angular/forms";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../store";
import {first, map, switchMap, takeUntil} from "rxjs/operators";
import {Website} from "../../../../websites/website/website";
import {Subject} from "rxjs";
import {filter} from "rxjs";
import {DbResponse} from "../../../interceptors/db-response";
import {UserManagementService} from "../../../../user-managment/user-management.service";
import {clientRoles} from "../../../../user/user-roles-actions";
import * as workspaceActions from "../../../../store/actions/workspace.action";
import {DbValidators} from "../../../validators/DbValidators";
import {DbServerErrors} from "../../../interceptors/db-server-errors";
import {GoogleAnalyticsService} from "../../../services/google-analytics/google-analytics.service";
import {TypeFormAnswers} from "../../../../add-website/typeFormAnswers";
import {IFcDropdownSelectOption} from "../../form-controls/dropdown-select/fc-dropdown-select-option";
import {combineLatest} from "rxjs";
import {Router} from "@angular/router";
import {UserService} from "../../../../user/user.service";
import {AgencyPartnerProgramDialogComponent} from "../../../../add-website/agency-partner-program-dialog/agency-partner-program-dialog.component";
import {TypeUtils} from "../../../utils/type-utils";
import {TextUtils} from "../../../utils/text-utils";
import {UserSubscription, UserSubscriptionCategory} from "../../../../user/user-subscription";

export interface IManageWorkspaceUsersDialogData {
  isInvite: boolean;
  ownerEmail?: string;
  userData?: any;
  userRole?: string;
  paidClient?: boolean;
  from?: 'header' | 'workspace_popup' | 'who-create-website';
  isAgency?: boolean;
  fromBuildWebsiteDialog?: boolean;
  currentSubscription?: UserSubscription;
}

export interface IManageWorkspaceDialogUserData {
  name: string;
  email: string;
  clientId: number;
  role: string;
  domains: number[];
}

@Component({
    selector: 'db-invite-user-dialog',
    templateUrl: './manage-workspace-users-dialog.component.html',
    styleUrls: ['./manage-workspace-users-dialog.component.scss'],
    standalone: false
})
export class ManageWorkspaceUsersDialogComponent extends DialogComponent<IManageWorkspaceUsersDialogData, any> implements OnInit, OnDestroy {

  @Input() isInvite: boolean;
  @Input() ownerEmail?: string;
  @Input() userData?: IManageWorkspaceDialogUserData;
  @Input() userRole?: string;
  @Input() from?: 'header' | 'workspace_popup' | 'who-create-website';
  @Input() paidClient?: boolean;
  @Input() isAgency?: boolean;
  @Input() fromBuildWebsiteDialog?: boolean;
  @Input() currentSubscription: UserSubscription;
  public emails: FormControl;
  public websiteFilter: FormControl;
  public role: FormControl;
  public roleOptions: Array<IFcDropdownSelectOption> = [
    {value: clientRoles.COMPANY_ADMIN, label: 'Admin', description: TextUtils.getText('text_workspaceAdminDescription')},
    {value: clientRoles.COMPANY_DEV, label: 'Contributor', description: TextUtils.getText('text_workspaceContributorDescription')},
    {value: clientRoles.SITE_DEV, label: 'Member', description: TextUtils.getText('text_workspaceMemberDescription')},
  ];
  public siteAccessOptions: any[] = [
    {value: 'full', label: 'Full access'},
    {value: 'staging', label: 'Staging only'}
  ];
  public pointsAgencyFreelance: { label: string, description: string }[] = [
    {label: 'Better workflow with your clients', description: 'Get approvals before pushing any changes live thanks to the staging environment.'},
    {label: 'Improve team management', description: 'Easily invite team members and define access right to multiple websites at once.'},
    {label: 'Productive and convenient collaboration', description: 'Have your own space for collaborating on website development with both your team and clients.'},
  ];
  public pointsSMBEnt: { label: string, description: string }[] = [
    {label: 'Improve team management', description: 'Easily invite team members and define access rights to all your project contributors at once.'},
    {label: 'Better workflow with your team', description: 'Approve all the changes on the staging environment before updating the live version of your website.'},
    {label: 'Productive and convenient collaboration', description: 'Have your own space for collaborating with your developers, designers, and marketers.'},
  ];
  public clientRoles = clientRoles;
  public toggled: boolean = false;
  public toggleFromTop: boolean = false;
  private websites: {[key: string]: Website } = {};
  public websitesCount: number = 0;
  public filteredWebsites: Website[];
  public selectedWebsites: Website[] = [];
  public serverErrors: DbServerErrors;
  public loading: boolean = false;
  public typeFormAnswers = TypeFormAnswers;
  public userLocalStorage;
  public agencyFreelancer: boolean = false;
  public smbEnt: boolean = false;
  public hasClient: boolean;
  public isMobile: boolean;

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  @ViewChild('selectDropdownToggle') selectDropdownToggle: ElementRef;
  @ViewChild('selectDropdown') selectDropdown: ElementRef;
  private currentWorkspaceId: number;
  private ownerWorkspaceId: number;

  constructor(
    private renderer: Renderer2,
    private _router: Router,
    private _userService: UserService,
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>,
    private _userManagementService: UserManagementService,
    private _googleAnalyticsService: GoogleAnalyticsService

) {
    super (_dialogService);
    this.role = new FormControl('', Validators.required);
    this.websiteFilter = new FormControl('');
    this.renderer.listen('document', 'click', (e: Event) => {
      this.toggled = this.selectDropdownToggle && this.selectDropdownToggle.nativeElement.contains(e.target) || this.selectDropdown && this.selectDropdown.nativeElement.contains(e.target);
    });
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 991;
    this.emails = new FormControl('',
      [Validators.required, DbValidators.commaSepEmail, DbValidators.maxQuantity(10),
        DbValidators.duplicate, DbValidators.hasValue(this.ownerEmail)]);
    const label = this.from === 'workspace_popup' ? 'User invite tooltip button click' : this.from === 'header' ? 'User invite header button click' : '';
    this.isInvite && this.sendToAnalytics('Popup visibility');
    this.isInvite && label && this.from !== 'who-create-website' && this.sendToAnalytics(label);
    this._store.select(fromStore.getWorkspaceLoaded)
      .pipe(
        filter(loaded => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getWorkspaceIdEntities),
          this._store.select(fromStore.getWorkspaceAllClients)
        )),
        first()
      )
      .subscribe( ([workspaceIdEntities, clients]) => {
        this.ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
        this.currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this.ownerWorkspaceId;
        this.hasClient = !!clients.length;
      });
    this._store.select(fromStore.getWebsitesLoaded)
      .pipe(
        filter(loaded => !!loaded),
        switchMap(() => this._store.select(fromStore.getWebsites)),
        first()
      ).pipe(
      map(websites => websites.filter(website => !website.parentId && website.isActive && ((this.currentSubscription && this.currentSubscription.type === UserSubscriptionCategory.BOOSTER) || !!website.domain_hash))),
      takeUntil(this._destroyStream$)
    )
      .subscribe(websites => {
      websites.forEach((website) => {
        this.websites[website.id] = website;
        website.type === 'live' && this.websitesCount++;
      });
      this.fillUserData(this.userData);
      this.filterUnselectedWebsites();
    });

    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter(loaded => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getUserLocalStorage)
        )),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([user, userLocalStorage]) => {
        if (user && user.signUpFor && user.signUpFor.Role && user.signUpFor.Role.id) {
          this.agencyFreelancer = user.agencyOrFreelancer;
          this.smbEnt = ![TypeFormAnswers.AGENCY, TypeFormAnswers.FREELANCE].includes(user.signUpFor.Role.id) && !user.agencyOrFreelancer;
        }
        this.userLocalStorage = userLocalStorage || {};
      });

    this.websiteFilter.valueChanges
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe(value => this.filterUnselectedWebsites(value));
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  private fillUserData(data): void {
    if (data) {
      this.emails.setValue(data.email);
      if (data.role !== clientRoles.SITE_DEV) {
        this.role.setValue(this.userData.role);
      } else {
        this.role.setValue(clientRoles.SITE_DEV);
        data.domains.forEach( domainId => {
          this.selectedWebsites.push(this.websites[domainId]);
        });
      }
    }
  }

  public toggleDropdown(): void {
    this.toggled = !this.toggled;
  }

  private filterUnselectedWebsites(value: string = ''): void {
    this.filteredWebsites = Object.values(this.websites).filter(website => website.title.toLowerCase().includes(value.toLowerCase()) && website.type === 'live' && !this.selectedWebsites.some((_website) => _website.id === website.id || _website.id === website.siblingId.dev
    ));
  }

  public selectWebsite(website: Website, index: number): void {
    this.selectedWebsites.push(website);
    this.filteredWebsites.splice(index, 1);
    this.toggled = false;
  }

  public unselectWebsite(index: number): void {
    this.selectedWebsites.splice(index, 1);
    this.filterUnselectedWebsites();
    this.toggled = false;
  }

  public updateSelectedSite(value, websiteSiblingId, index): void {
    this.selectedWebsites[index] = value === 'full' ? this.websites[websiteSiblingId.live] : this.websites[websiteSiblingId.dev];
  }

  public sendToAnalytics(label): void {
    const analyticsData = {
      eventCategory: 'User & Team Management',
      eventAction: 'Collaboration flow popup',
      eventLabel: label
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }


  public inviteUser(emails, domains): void {
    const result = {
      emails: JSON.stringify(emails),
      role_id: this.role.value,
      workspace: this.currentWorkspaceId,
      domains: domains
    };
    this._userManagementService.inviteUser(result)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this.sendToAnalytics('Invitation sent');
          this.userLocalStorage.inviteVisited && TypeUtils.isNull(this.fromBuildWebsiteDialog) && this.close();
          (!this.userLocalStorage.inviteVisited || !TypeUtils.isNull(this.fromBuildWebsiteDialog)) && this.setVisited();
          this._store.dispatch(new workspaceActions.LoadWorkspaceAllClients());
        }
        else {
          this.serverErrors = response.serverErrors;
        }
        this.loading = false;
      });
  }

  public updateUser(domains): void {
    const result = {
      role_id: this.role.value,
      domains: domains,
      client_id: this.userData && this.userData.clientId
    };
    this._userManagementService.updateUser(result)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe( response => {
      this.loading = false;
      if (response.success) {
        this._store.dispatch(new workspaceActions.LoadWorkspaceAllClients());
        this.close();
      }
      else {
        this.serverErrors = response.serverErrors;
      }
      this.loading = false;
    });
  }

  public handleRequest(): void {
    if (this.role.invalid || this.emails.invalid || (this.role.value === clientRoles.SITE_DEV && !this.selectedWebsites.length)) {
      return;
    }
    this.loading = true;
    this.serverErrors = null;
    const emails = this.emails.value.split(',').reduce((acc, item) => {
      if (item.trim()) {
        acc.push(item.trim());
      }
      return acc;
    }, []);
    const domains = this.role.value === clientRoles.SITE_DEV ? this.selectedWebsites.map(website => website.id) : [];
    this.isInvite ? this.inviteUser(emails, JSON.stringify(domains)) : this.updateUser(domains);
  }

  private setVisited(): void {
    this.userLocalStorage.inviteVisited = true;
    this._userService.setToLocal(this.userLocalStorage)
      .pipe(
        filter((_response: DbResponse): boolean => !!_response),
        first()
      )
      .subscribe((_response: DbResponse): void => {
        if (_response.success) {
          this._store.dispatch(new fromStore.LoadUserLocalStorage());
        }
        this.from === 'header' && !this.hasClient && this._dialogService.addDialog(AgencyPartnerProgramDialogComponent, {
          from: 'invite_user',
          width: '500px',
          title: 'Invitation Sent!',
          body: '<p>Congrats, you’ve sent your first invite.<br><br> You can manage user permissions or invite new users<br class="ds-hide-mobile"> in “User & Team Management".',
          btn: 'CONTINUE'
        });
        this.close();
      });
  }

  public changeDropdownPosition(event) {
    const _element = event.target.closest('li');
    this.toggleFromTop = (_element.offsetTop + _element.offsetParent.offsetTop > 20);
  }
}
